export const SET_TopicTree = 'SET_TopicTree';
export const SET_TopicList = 'SET_TopicList';
export const SET_KeywordList = 'SET_KeywordList';
export const SET_TopicTreeLearning = 'SET_TopicTreeLearning';
export const SET_TopicListLearning = 'SET_TopicListLearning';
export const SET_KeywordListLearning = 'SET_KeywordListLearning';
export const SET_TopicTreeTest = 'SET_TopicTreeTest';
export const SET_TopicListTest = 'SET_TopicListTest';
export const SET_LearningContents = 'SET_LearningContents';
export const SET_MockTest = 'SET_MockTest';
export const SET_ContentLimit = 'SET_ContentLimit';